import React, { useEffect, useRef, useState } from "react";
import { Form, Row, Col, InputGroup, FormText } from "react-bootstrap";
import {
  IconUser,
  IconFileDescription,
  IconPhone,
  IconWorldWww,
} from "@tabler/icons-react";
import { useFormContext, Controller } from "react-hook-form";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import DatePicker from "react-datepicker";
import { setContractName } from "../../redux/contrcatReducer";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
function GeneralStep({ isEditing, setType, Type }) {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  

  const handleTypeChange = (e) => {
    // reset();
    setType(e.target.value);
    setValue("CustomerType", e.target.value);
  };

  return (
    <>
      <Row className="">
        <Col md={3}>
          <Form.Group as={Col}>
            <div
              style={{
                display: "flex",
                gap: "2px 8px",
                flexWrap: "wrap",
              }}
            >
              <Form.Label className="w-md-auto" style={{ fontWeight: "bold" }}>
                Type:
              </Form.Label>

              <Form.Check>
                <Form.Check.Input
                  type="radio"
                  id="customerId"
                  value="INDIVIDUAL"
                  {...register("CustomerType")}
                  checked={Type === "INDIVIDUAL"}
                  onChange={handleTypeChange}
                />
                <Form.Check.Label htmlFor="customerId">
                  Individual
                </Form.Check.Label>
              </Form.Check>

              <Form.Check>
                <Form.Check.Input
                  type="radio"
                  id="CompanyId"
                  value="COMPANY"
                  {...register("CustomerType")}
                  checked={Type === "COMPANY"}
                  onChange={handleTypeChange}
                />
                <Form.Check.Label htmlFor="CompanyId">Company</Form.Check.Label>
              </Form.Check>
            </div>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">
              {Type === "INDIVIDUAL" ? "Person’s Name" : "Company Name"}
            </Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter Name"
                {...register("display_name")}
              />
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.display_name && (
              <span className="text-danger">{errors.display_name.message}</span>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Website</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter Website URL"
                {...register("web_addr")}
              />
              <InputGroup.Text>
                <IconWorldWww stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.web_addr && (
              <span className="text-danger">{errors.web_addr.message}</span>
            )}
          </Form.Group>
        </Col>
      </Row>
        <h5 className="mb-3"> <b>{Type === "INDIVIDUAL" ? "Person’s Contact" : "Contracting Officer"}</b>  </h5>
      <Row>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>First Name</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter First Name"
                {...register("first_name")}
              />
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              {errors.first_name && (
                <span className="text-danger">{errors.first_name.message}</span>
              )}
            </InputGroup>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Last Name</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter Last Name"
                {...register("last_name")}
              />
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.last_name && (
              <span className="text-danger">{errors.last_name.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="Enter Email"
                {...register("primary_email")}
              />
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors.primary_email && (
              <span className="text-danger">
                {errors.primary_email.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Phone Number</Form.Label>

            <InputGroup>
              <InputGroup.Text>
                <IconPhone stroke={1} />
              </InputGroup.Text>
              <Controller
                name="primary_phone"
                control={control}
                rules={{
                  required: "Phone number is required",
                  validate: (value) =>
                    (value && value.length > 0) || "Invalid phone number",
                }}
                render={({ field }) => (
                  <PhoneInput
                    className="form-control"
                    {...field}
                    defaultCountry="US"
                    countryCallingCodeEditable={false}
                    international
                    placeholder="Enter phone number"
                    onChange={field.onChange}
                  />
                )}
              />
            </InputGroup>
            {errors.primary_phone && (
              <span className="text-danger">
                {errors.primary_phone.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconFileDescription stroke={1} />
              </InputGroup.Text>
              <Form.Control
                as="textarea"
                {...register("Address")}
                placeholder="Enter Address"
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
              />
            </InputGroup>
            {errors.Address && (
              <span className="text-danger">{errors.Address.message}</span>
            )}
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}

export default GeneralStep;
